import { ISanityBlockContent } from '@rbi-ctg/menu';
import { IMarketingCardFragment } from 'generated/sanity-graphql';

export type ModalPayloadType = { heading: string; content: ISanityBlockContent[] };
export type OnShowModalType = (data: ModalPayloadType) => void;
export interface IMarketingCardProps {
  /** The card data form Sanity */
  card: IMarketingCardFragment;
  /** callback for showing the terms modal */
  onShowTermsModal: OnShowModalType;
  /** index of the marketing card */
  index: number;
}
